import { Gavel } from "lucide-react";

// Consistent "Bid Now" button used across every horse page.
// Renders only when a per-horse auction URL is provided.
export const BidNowButton = ({ url, testid = "bid-now-btn", className = "" }) => {
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      data-testid={testid}
      className={`flex h-12 w-full items-center justify-center gap-2 rounded-full bg-secondary font-bold text-white shadow-sm transition-transform hover:bg-secondary/90 active:scale-95 ${className}`}
    >
      <Gavel size={18} /> Bid Now
    </a>
  );
};
